export const TRPC_URL = import.meta.env.VITE_APP_TRPC_URL
